//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: String,
      default: 'all',
    },
    planTypes: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
  computed: {
    validTypes() {
      return this.planTypes.map((type) => type.key);
    },
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
  },
};
